module.exports = __webpack_public_path__ + "static/media/Oscar-Tiye-Black-Minnie-Leather-Sandals-Lyst_thumb.2af13b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Oscar-Tiye-Black-Minnie-Leather-Sandals-Lyst_thumb.png
// module id = 284
// module chunks = 0